import { motion } from 'framer-motion';

// Animated wave that sits at the bottom of sections
export const AnimatedWave = ({ className = '', color = '#FFFFFF' }) => {
  return (
    <div className={`absolute bottom-0 left-0 right-0 overflow-hidden ${className}`}>
      <svg 
        className="relative block w-full h-[120px] md:h-[180px]"
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
      >
        <motion.path 
          fill={color}
          fillOpacity="0.3"
          initial={{ d: "M0,160L48,181.3C96,203,192,245,288,234.7C384,224,480,160,576,138.7C672,117,768,139,864,165.3C960,192,1056,224,1152,213.3C1248,203,1344,149,1392,122.7L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" }}
          animate={{ 
            d: [
              "M0,160L48,181.3C96,203,192,245,288,234.7C384,224,480,160,576,138.7C672,117,768,139,864,165.3C960,192,1056,224,1152,213.3C1248,203,1344,149,1392,122.7L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
              "M0,128L48,149.3C96,171,192,213,288,218.7C384,224,480,192,576,165.3C672,139,768,117,864,128C960,139,1056,181,1152,197.3C1248,213,1344,203,1392,197.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
              "M0,192L48,176C96,160,192,128,288,133.3C384,139,480,181,576,197.3C672,213,768,203,864,176C960,149,1056,107,1152,101.3C1248,96,1344,128,1392,144L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
              "M0,160L48,181.3C96,203,192,245,288,234.7C384,224,480,160,576,138.7C672,117,768,139,864,165.3C960,192,1056,224,1152,213.3C1248,203,1344,149,1392,122.7L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ]
          }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.path 
          fill={color}
          fillOpacity="0.5"
          initial={{ d: "M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,218.7C672,235,768,245,864,234.7C960,224,1056,192,1152,181.3C1248,171,1344,181,1392,186.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" }}
          animate={{ 
            d: [
              "M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,218.7C672,235,768,245,864,234.7C960,224,1056,192,1152,181.3C1248,171,1344,181,1392,186.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
              "M0,256L48,240C96,224,192,192,288,186.7C384,181,480,203,576,213.3C672,224,768,224,864,218.7C960,213,1056,203,1152,208C1248,213,1344,235,1392,245.3L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
              "M0,192L48,208C96,224,192,256,288,261.3C384,267,480,245,576,224C672,203,768,181,864,186.7C960,192,1056,224,1152,234.7C1248,245,1344,235,1392,229.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
              "M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,218.7C672,235,768,245,864,234.7C960,224,1056,192,1152,181.3C1248,171,1344,181,1392,186.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ]
          }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.path 
          fill={color}
          initial={{ d: "M0,288L48,272C96,256,192,224,288,218.7C384,213,480,235,576,250.7C672,267,768,277,864,272C960,267,1056,245,1152,234.7C1248,224,1344,224,1392,224L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" }}
          animate={{ 
            d: [
              "M0,288L48,272C96,256,192,224,288,218.7C384,213,480,235,576,250.7C672,267,768,277,864,272C960,267,1056,245,1152,234.7C1248,224,1344,224,1392,224L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
              "M0,256L48,261.3C96,267,192,277,288,277.3C384,277,480,267,576,261.3C672,256,768,256,864,261.3C960,267,1056,277,1152,277.3C1248,277,1344,267,1392,261.3L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
              "M0,288L48,282.7C96,277,192,267,288,261.3C384,256,480,256,576,266.7C672,277,768,299,864,293.3C960,288,1056,256,1152,250.7C1248,245,1344,267,1392,277.3L1440,288L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
              "M0,288L48,272C96,256,192,224,288,218.7C384,213,480,235,576,250.7C672,267,768,277,864,272C960,267,1056,245,1152,234.7C1248,224,1344,224,1392,224L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ]
          }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
        />
      </svg>
    </div>
  );
};

// Water droplets floating animation for hero backgrounds
export const WaterDroplets = ({ count = 20 }) => {
  const droplets = Array.from({ length: count }, (_, i) => ({
    id: i,
    size: Math.random() * 20 + 5,
    left: Math.random() * 100,
    delay: Math.random() * 5,
    duration: Math.random() * 10 + 10,
    opacity: Math.random() * 0.3 + 0.1
  }));

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {droplets.map((drop) => (
        <motion.div
          key={drop.id}
          className="absolute rounded-full bg-white"
          style={{
            width: drop.size,
            height: drop.size,
            left: `${drop.left}%`,
            opacity: drop.opacity,
          }}
          initial={{ y: '120vh', scale: 0 }}
          animate={{ 
            y: '-20vh', 
            scale: [0, 1, 1, 0],
          }}
          transition={{
            duration: drop.duration,
            repeat: Infinity,
            delay: drop.delay,
            ease: 'linear'
          }}
        />
      ))}
    </div>
  );
};

// Horizontal flowing wave for section dividers
export const FlowingWaveDivider = ({ fromColor = '#1E3A8A', toColor = '#FFFFFF' }) => {
  return (
    <div className="relative w-full h-32 md:h-48 overflow-hidden" style={{ background: fromColor }}>
      <svg 
        className="absolute bottom-0 w-full h-full"
        viewBox="0 0 1440 200" 
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={toColor} stopOpacity="0.2" />
            <stop offset="50%" stopColor={toColor} stopOpacity="0.5" />
            <stop offset="100%" stopColor={toColor} stopOpacity="0.2" />
          </linearGradient>
        </defs>
        
        <motion.path
          fill="url(#waveGradient)"
          animate={{
            d: [
              "M0 100 Q 360 50 720 100 T 1440 100 L1440 200 L0 200 Z",
              "M0 100 Q 360 150 720 100 T 1440 100 L1440 200 L0 200 Z",
              "M0 100 Q 360 50 720 100 T 1440 100 L1440 200 L0 200 Z"
            ]
          }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.path
          fill={toColor}
          animate={{
            d: [
              "M0 120 Q 360 80 720 120 T 1440 120 L1440 200 L0 200 Z",
              "M0 120 Q 360 160 720 120 T 1440 120 L1440 200 L0 200 Z",
              "M0 120 Q 360 80 720 120 T 1440 120 L1440 200 L0 200 Z"
            ]
          }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        />
      </svg>
    </div>
  );
};

// Original simple wave dividers
export const WaveDivider = ({ variant = 'top', color = 'white', className = '' }) => {
  const bgColor = color === 'white' ? '#FFFFFF' : color === 'dark' ? '#0F172A' : color === 'primary' ? '#1E3A8A' : color;
  
  if (variant === 'top') {
    return (
      <div className={`relative w-full overflow-hidden ${className}`} style={{ marginTop: '-1px' }}>
        <svg 
          className="w-full h-16 md:h-24" 
          viewBox="0 0 1440 100" 
          preserveAspectRatio="none"
          fill={bgColor}
        >
          <path d="M0,100 L0,40 Q180,80 360,40 T720,40 T1080,40 T1440,40 L1440,100 Z" />
        </svg>
      </div>
    );
  }
  
  if (variant === 'bottom') {
    return (
      <div className={`relative w-full overflow-hidden ${className}`} style={{ marginBottom: '-1px' }}>
        <svg 
          className="w-full h-16 md:h-24" 
          viewBox="0 0 1440 100" 
          preserveAspectRatio="none"
          fill={bgColor}
        >
          <path d="M0,0 L0,60 Q180,20 360,60 T720,60 T1080,60 T1440,60 L1440,0 Z" />
        </svg>
      </div>
    );
  }
  
  return null;
};

export const AnimatedWaveDivider = ({ variant = 'top', fromColor = 'white', toColor = 'dark', className = '' }) => {
  const fillColor = variant === 'top' ? 
    (toColor === 'white' ? '#FFFFFF' : toColor === 'dark' ? '#0F172A' : toColor === 'primary' ? '#1E3A8A' : toColor) :
    (fromColor === 'white' ? '#FFFFFF' : fromColor === 'dark' ? '#0F172A' : fromColor === 'primary' ? '#1E3A8A' : fromColor);

  return (
    <div className={`relative w-full overflow-hidden ${className}`}>
      <motion.div
        className="flex"
        style={{ width: '200%' }}
        animate={{ x: [0, '-50%'] }}
        transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
      >
        {variant === 'top' ? (
          <>
            <svg className="w-1/2 h-16 md:h-24" viewBox="0 0 1440 100" preserveAspectRatio="none" fill={fillColor}>
              <path d="M0,100 L0,30 Q120,60 240,30 Q360,0 480,30 Q600,60 720,30 Q840,0 960,30 Q1080,60 1200,30 Q1320,0 1440,30 L1440,100 Z">
                <animate
                  attributeName="d"
                  dur="8s"
                  repeatCount="indefinite"
                  values="
                    M0,100 L0,30 Q120,60 240,30 Q360,0 480,30 Q600,60 720,30 Q840,0 960,30 Q1080,60 1200,30 Q1320,0 1440,30 L1440,100 Z;
                    M0,100 L0,40 Q120,10 240,40 Q360,70 480,40 Q600,10 720,40 Q840,70 960,40 Q1080,10 1200,40 Q1320,70 1440,40 L1440,100 Z;
                    M0,100 L0,30 Q120,60 240,30 Q360,0 480,30 Q600,60 720,30 Q840,0 960,30 Q1080,60 1200,30 Q1320,0 1440,30 L1440,100 Z"
                />
              </path>
            </svg>
            <svg className="w-1/2 h-16 md:h-24" viewBox="0 0 1440 100" preserveAspectRatio="none" fill={fillColor}>
              <path d="M0,100 L0,30 Q120,60 240,30 Q360,0 480,30 Q600,60 720,30 Q840,0 960,30 Q1080,60 1200,30 Q1320,0 1440,30 L1440,100 Z">
                <animate
                  attributeName="d"
                  dur="8s"
                  repeatCount="indefinite"
                  values="
                    M0,100 L0,30 Q120,60 240,30 Q360,0 480,30 Q600,60 720,30 Q840,0 960,30 Q1080,60 1200,30 Q1320,0 1440,30 L1440,100 Z;
                    M0,100 L0,40 Q120,10 240,40 Q360,70 480,40 Q600,10 720,40 Q840,70 960,40 Q1080,10 1200,40 Q1320,70 1440,40 L1440,100 Z;
                    M0,100 L0,30 Q120,60 240,30 Q360,0 480,30 Q600,60 720,30 Q840,0 960,30 Q1080,60 1200,30 Q1320,0 1440,30 L1440,100 Z"
                />
              </path>
            </svg>
          </>
        ) : (
          <>
            <svg className="w-1/2 h-16 md:h-24" viewBox="0 0 1440 100" preserveAspectRatio="none" fill={fillColor}>
              <path d="M0,0 L0,70 Q120,40 240,70 Q360,100 480,70 Q600,40 720,70 Q840,100 960,70 Q1080,40 1200,70 Q1320,100 1440,70 L1440,0 Z">
                <animate
                  attributeName="d"
                  dur="8s"
                  repeatCount="indefinite"
                  values="
                    M0,0 L0,70 Q120,40 240,70 Q360,100 480,70 Q600,40 720,70 Q840,100 960,70 Q1080,40 1200,70 Q1320,100 1440,70 L1440,0 Z;
                    M0,0 L0,60 Q120,90 240,60 Q360,30 480,60 Q600,90 720,60 Q840,30 960,60 Q1080,90 1200,60 Q1320,30 1440,60 L1440,0 Z;
                    M0,0 L0,70 Q120,40 240,70 Q360,100 480,70 Q600,40 720,70 Q840,100 960,70 Q1080,40 1200,70 Q1320,100 1440,70 L1440,0 Z"
                />
              </path>
            </svg>
            <svg className="w-1/2 h-16 md:h-24" viewBox="0 0 1440 100" preserveAspectRatio="none" fill={fillColor}>
              <path d="M0,0 L0,70 Q120,40 240,70 Q360,100 480,70 Q600,40 720,70 Q840,100 960,70 Q1080,40 1200,70 Q1320,100 1440,70 L1440,0 Z">
                <animate
                  attributeName="d"
                  dur="8s"
                  repeatCount="indefinite"
                  values="
                    M0,0 L0,70 Q120,40 240,70 Q360,100 480,70 Q600,40 720,70 Q840,100 960,70 Q1080,40 1200,70 Q1320,100 1440,70 L1440,0 Z;
                    M0,0 L0,60 Q120,90 240,60 Q360,30 480,60 Q600,90 720,60 Q840,30 960,60 Q1080,90 1200,60 Q1320,30 1440,60 L1440,0 Z;
                    M0,0 L0,70 Q120,40 240,70 Q360,100 480,70 Q600,40 720,70 Q840,100 960,70 Q1080,40 1200,70 Q1320,100 1440,70 L1440,0 Z"
                />
              </path>
            </svg>
          </>
        )}
      </motion.div>
    </div>
  );
};

export default WaveDivider;
